

















































































































































import { Prop, Vue, Component } from "vue-property-decorator";
import {
  teacherRelationStudentListApi,
  relationStudentRelationApi,
} from "@/api/teacherManage";
import { searchStudent } from "@/api/globalSearch";
@Component
export default class extends Vue {
  @Prop() t_id!: number;
  selectedObject: any = {};
  selectedList: any[] = []; // 课程列表
  courseIdList: number[] = [];
  dialogVisible = false;
  searchInfo = {
    key_word: "",
    remarks: "",
  };
  studentTableData: any[] = [];
  classTableData: any = [];
  showConfirm: boolean = false; //显示自定义弹框;
  relationMessage: string = ""; // 弹框信息
  sid: number = 0; //学员id
  rules = {
    remarks: [{ required: true, message: "请填写备注信息", trigger: "blur" }],
  };
  created() {}
  showDialog() {
    this.dialogVisible = true;
    this.searchInfo.remarks = "";
    this.getList({
      page: 1,
      page_size: 100,
    });
  }
  getList(params: { page: number; page_size: number }) {
    const data: any = {
      page: params.page,
      page_size: params.page_size,
      status: [2, 3],
    };
    if (this.searchInfo.key_word) {
      data.key_word = this.searchInfo.key_word;
    }
    searchStudent(data).then((res: any) => {
      res.data.list.map((item: any) => {
        if (this.selectedObject[item.student_id]) {
          item.checked = true;
        } else {
          item.checked = false;
        }
      });
      this.studentTableData = res.data.list;
    });
  }
  getTeacherRelationStudentList(params: { page: number; page_size: number }) {
    const option: any = {
      page: params.page,
      page_size: params.page_size,
    };
    if (this.searchInfo.key_word) {
      option.key_word = this.searchInfo.key_word;
    }
    teacherRelationStudentListApi({
      teacher_id: Number(this.t_id),
      student_id: Number(this.sid),
      page: 1,
      page_size: 100,
    }).then((res: any) => {
      if (res.error_code === 0) {
        res.data.list.map((item: any) => {
          item.checked = false;
        });
        this.classTableData = res.data.list;
      }
    });
  }
  handleCancel() {
    this.dialogVisible = false;
    this.selectedObject = {};
    this.selectedList = [];
    this.searchInfo.key_word = "";
  }
  handleConfirm() {
    (this.$refs["form"] as Vue & { validate: Function }).validate(
      (valid: boolean) => {
        if (valid) {
          if (this.selectedList.length === 0) {
            this.$message({
              type: "error",
              message: "请选择学员",
            });
            return;
          }
          const c_ids: number[] = [];
          this.selectedList.map((item: any) => {
            c_ids.push(Number(item.course_id));
          });
          relationStudentRelationApi({
            teacher_id: this.t_id,
            student_id: this.sid,
            remark: this.searchInfo.remarks,
            course_ids: c_ids,
          }).then((res: any) => {
            if (res.error_code === 21004018) {
              this.relationMessage = res.message;
              this.showConfirm = true;
            }
            if (res.error_code === 0) {
              this.$message({
                type: "success",
                message: "关联成功",
              });
              this.dialogVisible = false;
              this.$emit("change", "");
            }
          });
        }
      }
    );
  }
  concel() {
    this.showConfirm = false;
  }
  setUp() {
    const goStudent = this.$router.resolve({
      name: "studentManage",
      query: {},
    });
    window.open(goStudent.href, "_blank");
  }
  confirmBtn() {
    const c_ids: number[] = [];
    this.selectedList.map((item: any) => {
      c_ids.push(Number(item.course_id));
    });
    relationStudentRelationApi({
      teacher_id: this.t_id,
      student_id: this.sid,
      remark: this.searchInfo.remarks,
      course_ids: c_ids,
    }).then((res: any) => {
      if (res.error_code === 0) {
        this.showConfirm = false;
        this.$message({
          type: "success",
          message: "关联成功",
        });
        this.dialogVisible = false;
        this.$emit("change", "");
      }
    });
  }
  handleSearch(val: any) {
    this.getList({
      page: 1,
      page_size: 1000,
    });
    this.classTableData = [];
  }
  handleAreaCodeSelect(info: any) {
    this.sid = info.student_id;
    if (info.checked === false) {
      this.classTableData = [];
      return;
    }
    this.studentTableData.map((item: any) => {
      if (item.student_id !== info.student_id) {
        item.checked = false;
      } else {
        this.getTeacherRelationStudentList({
          page: 1,
          page_size: 100,
        });
      }
    });
  }
  handleSelectionChange(val: any) {
    this.selectedList = val;
  }
  notHandtable(it: any, ind: number) {
    if (it.relation_status === false) {
      return true;
    }
  }
}
